<template>
  <router-link class="detail-link btn-primary" :to="`/inspection/${hgFolderId}`">
    Inspection Details
  </router-link>
</template>

<script>
export default {
  props: {
    hgFolderId: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-link {
  padding: 10px 20px;
}
</style>
